import Vue from "vue";

Vue.directive("open-mobile-search",
    {
        bind(el, binding)
        {
            el.onclick = function(event)
            {
                event.preventDefault();
                document.querySelector(".dia-shop-nav__search").classList.toggle("dia-shop-nav__search--open");
                if(document.querySelector(".dia-shop-nav__search").classList.contains('dia-shop-nav__search--open')){
                    document.querySelector(".dia-shop-nav__search").focus();
                }
            };
        }
    });
